import React, { useState, useEffect } from 'react';
import { StyleSheet, Image, ActivityIndicator, View } from 'react-native';
import { useHistory } from 'react-router';
import { useMutation } from '@apollo/react-hooks';

import { Card, TextInput, Text, Button } from '../core-ui';
import { TEXT } from '../constants/colors';
import { LOGIN_MUTATION } from '../graphql/mutations/login';
import { saveToken, saveRole, getToken } from '../helpers/storage';
import { normalizeError } from '../helpers/normalizeText';
import {
  LoginMutation,
  LoginMutationVariables,
} from '../generated/LoginMutation';
import { Role } from '../generated/globalTypes';

import { insightsLogo } from '../../assets';
import SVG from '../../assets/svg';

export default function LoginScene() {
  let routerHistory = useHistory();

  let [email, setEmail] = useState('');
  let [password, setPassword] = useState('');
  let [errorText, setErrorText] = useState('');
  let [loginMutation, { loading }] = useMutation<
    LoginMutation,
    LoginMutationVariables
  >(LOGIN_MUTATION, {
    onError: (error) => setErrorText(error.message),
    onCompleted: (data) =>
      onLoginSucceeded(data.login.token, data.login.user.role),
  });

  useEffect(() => {
    getToken().then((token) => {
      if (token) {
        routerHistory.push('/dashboard');
      }
    });
  }, []);

  let renderBackgroundImage = () => {
    return React.createElement(SVG.loginBackground);
  };

  let isFieldEmpty = () => {
    if (email === '' || password === '') {
      return true;
    }
    return false;
  };

  let onLoginSucceeded = (token: string, role: Role) => {
    saveToken(token);
    saveRole(role.toString());
    routerHistory.push('/dashboard');
  };

  let onSubmitPress = () => {
    setErrorText('');
    if (!isFieldEmpty()) {
      loginMutation({
        variables: { email, password },
      });
    } else {
      setErrorText("Field can't empty");
    }
  };

  return (
    <View style={styles.container}>
      <View style={{ position: 'absolute' }}>{renderBackgroundImage()}</View>

      <Card style={styles.cardContainer}>
        <Image source={insightsLogo} style={styles.logo} resizeMode="contain" />
        <TextInput
          onSubmitEditing={onSubmitPress}
          label="Email Address"
          placeholder="Please enter your email"
          value={email}
          onChangeText={(text) => setEmail(text)}
        />
        <TextInput
          onSubmitEditing={onSubmitPress}
          label="Password"
          placeholder="Please enter your password"
          value={password}
          onChangeText={(text) => setPassword(text)}
          secureTextEntry={true}
        />
        {errorText ? (
          <Text type="header" color={TEXT.red} style={styles.errorText}>
            {normalizeError(errorText)}
          </Text>
        ) : null}
        {loading ? (
          <ActivityIndicator size="large" />
        ) : (
          <Button
            title="Log In"
            onPress={onSubmitPress}
            style={styles.button}
          />
        )}
      </Card>
      <Text type="default" style={styles.footer}>
        Insights by KodeFox
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  flex: {
    flex: 1,
  },
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardContainer: {
    width: 404,
    maxWidth: 404,
    padding: 42,
  },
  logo: {
    height: 36,
    marginBottom: 40,
  },
  button: {
    margin: 0,
  },
  errorText: {
    alignSelf: 'center',
    marginBottom: 10,
  },
  footer: {
    position: 'absolute',
    bottom: '4%',
    alignSelf: 'center',
    color: TEXT.white,
    opacity: 0.6,
  },
});
